module.exports = __webpack_public_path__ + "public/images/schedule/schedule-wel.b2bd286c3ac8e8d0e64c5deedd839f5c.svg";